import dateFormat from 'dateformat'

/**
 * these helpers produces better vm code in JS engines due to their
 * explicitness and function inlining
 * @param value
 * @returns {boolean}
 */

/**
 * @param value {any}
 * @returns {boolean}
 */
export function isString (value) {
  return typeof value === 'string'
}

/**
 * @param value {any}
 * @returns {boolean}
 */
export function isDate (value) {
  return value instanceof Date
}

export function isArray (value) {
  return value instanceof Array
}

export function isObject (value) {
  return typeof value === 'object'
}

export function isNllUdf (value) {
  return value === undefined || value === null
}

export function isEmpty (value) {
  if (typeof value === 'boolean') {
    return false
  }
  if (!value) {
    return true
  }
  if (typeof value === 'string' && value.trim() === '') {
    return true
  }
  return false
}

export function isResponse (value) {
  if (!value) {
    return false
  }
  if (value instanceof Response) {
    return true
  }
  return value.ok !== undefined &&
    value.status !== undefined &&
    value.statusText !== undefined &&
    value.url !== undefined &&
    value.body !== undefined &&
    value.json !== undefined
}

/**
 * 包裹一个方法，返回参数的同时，执行某个方法
 * @param func {Function<T>}
 * @returns {function(*=)}
 */
export function also (func) {
  return (data) => {
    func(data)
    return data
  }
}

export const delay = (ms) => {
  return new Promise(resolve => void setTimeout(resolve, ms))
}

export const delayAndReturnSelf = (ms) => {
  return (data) => Promise.resolve()
    .then(() => delay(ms))
    .then(() => Promise.resolve(data))
}

export const spDateFormat = date =>
  date instanceof Date
    ? dateFormat(date, 'yyyy-mm-dd HH:MM:ss')
    : date

export const spDateOnly = date =>
  date instanceof Date
    ? dateFormat(date, 'yyyy-mm-dd')
    : date

export function getTheEndDateOfTheMonth (date) {
  if (!(date instanceof Date)) {
    return
  }
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  if (month === 13) {
    year++
    month = 1
  }
  const nextMonth = new Date(year, month)
  return new Date(nextMonth.getTime() - 1)
}

export function getTheEndDateOfTheYear (date) {
  if (!(date instanceof Date)) {
    return
  }
  let year = date.getFullYear()
  return new Date(new Date(year + 1, 0).getTime() - 1)
}

export function transformMoney (money, ifNull) {
  if (isNllUdf(money)) {
    return ifNull
  }
  return (money * 1).toFixed(2)
}

export function debounce (fn, delay) {
  // 维护一个 timer
  let timer = null

  return function () {
    // 获取函数的作用域和变量
    const context = this
    const args = arguments

    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args)
    }, delay)
  }
}



// WEBPACK FOOTER //
// ./src/utils/util.js